var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeatingChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 10V10C4.567 10 3 8.433 3 6.5V6.5C3 4.567 4.567 3 6.5 3V3C8.433 3 10 4.567 10 6.5V6.5C10 8.433 8.433 10 6.5 10Z",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 10V10C15.567 10 14 8.433 14 6.5V6.5C14 4.567 15.567 3 17.5 3V3C19.433 3 21 4.567 21 6.5V6.5C21 8.433 19.433 10 17.5 10Z",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 21V21C4.567 21 3 19.433 3 17.5V17.5C3 15.567 4.567 14 6.5 14V14C8.433 14 10 15.567 10 17.5V17.5C10 19.433 8.433 21 6.5 21Z",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 17.5V17.5C21 15.567 19.433 14 17.5 14V14C15.567 14 14 15.567 14 17.5V17.5C14 19.433 15.567 21 17.5 21V21C19.433 21 21 19.433 21 17.5Z",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeatingChart);
export default __webpack_public_path__ + "static/media/seating-chart.5408e138.svg";
export { ForwardRef as ReactComponent };